import { Avatar, CardHeaderOwnProps, Stack, useTheme } from "@mui/material"
import { ReactElement } from "react"

import { useScreenSize } from "../../hooks/useScreenSize"
import { GRID_SPACING } from "../../themes/defaultThemeParams"
import { AppCardHeader } from "../surfaces/appCard"
import DisplayIf from "../wrappers/displayIf"

interface FormHeaderProps {
    header: string
    subHeader?: string
    index: number
    headerTypography?: CardHeaderOwnProps["titleTypographyProps"]
    subHeaderTypography?: CardHeaderOwnProps["subheaderTypographyProps"]
}

/** Component used to display title, subheading and number of a given page in a form */
const FormHeader = ({
    header,
    subHeader = "",
    index,
    headerTypography = {},
    subHeaderTypography = {},
}: FormHeaderProps): ReactElement => {
    const theme = useTheme()
    const { isMob } = useScreenSize()
    return (
        <Stack direction="row" alignItems="center" spacing={GRID_SPACING}>
            <DisplayIf condition={!isMob}>
                <Avatar
                    color="primary"
                    sx={{
                        marginTop: 1.2,
                        background: theme.palette.primary.main,
                    }}
                >
                    {index}
                </Avatar>
            </DisplayIf>
            <AppCardHeader
                title={header}
                subheader={subHeader}
                subheaderTypographyProps={subHeaderTypography}
                titleTypographyProps={headerTypography}
                sx={{ width: "100%" }}
            />
        </Stack>
    )
}

FormHeader.defaultProps = {
    headerTypography: {},
    subHeaderTypography: {},
    subHeader: "",
}

export default FormHeader
